import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://sqshowtexrmyaoonkocc.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_iMcdofOQdR87ip0N22I9zA_hZZ5xDba';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
